//#region src/assets/check-circle.png
var check_circle_default = "" + new URL("check-circle-ca7eOdXe.png", import.meta.url).href;
//#endregion
export { check_circle_default as default };

//# sourceMappingURL=check-circle.js.map